import styled from 'styled-components';

export const SectionCard = styled.section`
  border: ${({ theme }) => theme.borders.border1};
  border-radius: 20px;
  background: ${({ theme }) => theme.white};
  padding: 20px 24px;

  @media (max-width: 800px) {
    padding: 16px;
  }
`;

export const SectionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

/* Every block in a section is separated by the same gap, so the blocks
   themselves carry no margins. */
export const BlockStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const BulletList = styled.ul`
  margin: 0;
  padding-left: 18px;

  li {
    font-size: 14px;
    line-height: 1.5;
    color: ${({ theme }) => theme.darkGray};

    & + li {
      margin-top: 8px;
    }
  }
`;

export const StepList = styled.ol`
  margin: 0;
  padding-left: 18px;

  li {
    font-size: 14px;
    line-height: 1.5;
    color: ${({ theme }) => theme.darkGray};

    & + li {
      margin-top: 8px;
    }
  }
`;

/* A screenshot of the screen the section describes. align-self matters: the
   block stack is a column flex container, so the default stretch would set
   the image's width to the whole card and squash a near-square dialog out of
   shape. Left alone it keeps its own ratio, capped by height. */
export const SectionImage = styled.img`
  display: block;
  align-self: flex-start;
  max-width: 100%;
  max-height: 360px;
  width: auto;
  height: auto;
  object-fit: contain;
  border: ${({ theme }) => theme.borders.border1};
  border-radius: 12px;
`;

export const LinkRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 20px;

  /* TextButton is width:100% by default, which would drop every link onto a
     line of its own inside this row. */
  > button {
    width: auto;
  }
`;
